import React from 'react';
import { Icon } from 'ui';

const DisplayCompletionTime = ({
  estimatedMinutesToComplete,
  onToggleEditMode,
}) => (
  <div className="d-f jc-sb mt-16">
    <span className="c-brand-gray-darker mr-8">
      {`${estimatedMinutesToComplete} ${t(
        'paths.path_builder.sidebar.completion_time.minutes',
      )}`}
    </span>
    <button
      type="button"
      onClick={onToggleEditMode}
      className="u-linkBtn fz-base fw-n"
    >
      <Icon name="edit" className="mr-4" />
      Edit
    </button>
  </div>
);

export default DisplayCompletionTime;
